module.exports = __webpack_public_path__ + "img/work-4.88360ea0.png";